import { Component, OnInit } from '@angular/core'
import { ToastrModule, ToastrService } from 'ngx-toastr'
import { ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { MatDialog, MatDialogModule } from '@angular/material/dialog'
import { ConfirmationDialogComponent } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component'
import { DatatableComponent } from '../../../shared/components/master-datatable/master-datatable.component'
import { MasterAddUpdateDialogComponent } from '../../../shared/components/master-add-update-dialog/master-add-update-dialog.component'
import { PaymentTypeModel } from './paymentType.model'
import { PaymentTypeService } from './paymentType.service'
import { MasterDatabaseDisplayModel } from '../../../shared/master-database-display.model'
import { MasterCommonServices } from '../../quotation/master.common.service'

@Component({
  selector: 'app-paymenttype.master',
  standalone: true,
  imports: [
    ToastrModule,
    ReactiveFormsModule,
    CommonModule,
    DatatableComponent,
  ],
  templateUrl: './paymentType.master.component.html',
  styleUrl: './paymentType.master.component.css',
})
export class PaymentTypeMasterComponent {
  paymenttypesData: PaymentTypeModel[] = []
  paymenttypeColumns: MasterDatabaseDisplayModel[] = [
    {
      key: 'paymentType',
      displayName: 'Payment Type Name',
      hiddenDataTable: false,
      hiddenDialog: false,
      type: 'text',
    },
    {
      key: 'addedOn',
      displayName: 'Added Date',
      hiddenDataTable: false,
      hiddenDialog: true,
      type: 'date',
    },
    {
      key: 'id',
      displayName: 'Id',
      hiddenDataTable: true,
      hiddenDialog: true,
      type: 'text',
    },
  ]
  isLoading: boolean = false

  constructor(
    private paymenttypeService: PaymentTypeService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public masterCommonService: MasterCommonServices,
  ) {}

  openAddUpdatePaymentTypeDialog(
    mode: string,
    paymenttype?: PaymentTypeModel,
  ): void {
    const fields = this.paymenttypeColumns
    const dialogRef = this.dialog.open(MasterAddUpdateDialogComponent, {
      data: { item: paymenttype || {}, mode, fields },
    })

    dialogRef.afterClosed().subscribe((result) => {
      

      if (result) {
        if (mode === 'update') {
          this.updatePaymentType(result)
        } else {
          this.addPaymentType(result)
        }
      }
    })
  }

  addPaymentType(paymenttype: PaymentTypeModel): void {
    this.paymenttypeService.addPaymentType(paymenttype).subscribe({
      next: () => {
        this.toastr.success('Payment Type Added Successfully!', 'Success')
        this.masterCommonService.getAllPayments()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  updatePaymentType(paymenttype: any): void {
    this.paymenttypeService.updatePaymentType(paymenttype).subscribe({
      next: () => {
        this.toastr.success('Payment Type Updated Successfully!', 'Success')
        this.masterCommonService.getAllPayments()
      },
      error: (error: any) => {
        this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
      },
    })
  }

  deletePaymentType(paymenttype: PaymentTypeModel): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: { message: 'Are you sure you want to delete this payment type?' },
    })
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        paymenttype.isDeleted = true
        this.paymenttypeService.deletePaymentType(paymenttype).subscribe({
          next: () => {
            this.paymenttypesData = this.paymenttypesData.filter(
              (p) => p.id !== paymenttype.id,
            )
            this.toastr.success('Payment Type Deleted Successfully!', 'Success')
          },
          error: (error: any) => {
            this.toastr.error(error.statusText, 'Error', { timeOut: 15000,
  closeButton: true,
  progressBar: true, })
          },
        })
      }
    })
  }
}
